/**
 * dsm-animate.js — DSM 进场动画观察器
 * 用途: 监听 [data-animate] 元素进入视口，添加 .is-animated 触发 CSS transition
 * 依赖: assets/dsm-animate.css
 * 使用:
 *   <div data-animate="fade-up">...</div>
 *   <div data-animate="fade-up" data-animate-delay="100">...</div>
 *   <div data-animate="fade-in" data-animate-once="false">...</div>
 */
;(function () {
  // 浏览器不支持 IntersectionObserver 时静默降级（直接显示元素）
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      el.classList.add('is-animated')
    })
    return
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target
        var once = el.dataset.animateOnce !== 'false' // 默认只触发一次

        if (entry.isIntersecting) {
          var delay = parseInt(el.dataset.animateDelay, 10) || 0

          setTimeout(function () {
            el.classList.add('is-animated')

            // 动画完成后移除 will-change，释放合成层
            el.addEventListener(
              'transitionend',
              function () {
                el.style.willChange = 'auto'
              },
              { once: true }
            )
          }, delay)

          // 默认只触发一次，触发后停止观察
          if (once) observer.unobserve(el)
        } else if (!once) {
          // data-animate-once="false"：离开视口后重置，下次再进入时重新触发
          el.classList.remove('is-animated')
          el.style.willChange = 'opacity, transform'
        }
      })
    },
    {
      threshold: 0.1,   // 元素露出 10% 时触发
      rootMargin: '0px' // 无提前触发，与视口齐平
    }
  )

  /**
   * 初始化所有 [data-animate] 元素
   */
  function init() {
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      // 动画期间激活 will-change，提示浏览器提前创建合成层
      el.style.willChange = 'opacity, transform'
      observer.observe(el)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
